import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';


@Component({
  selector: 'app-assement',
  templateUrl: './profileques.component.html',
  styleUrls: ['./profileques.component.css']
})
export class ProfilequesComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>;
  imageURL: string = environment.cloudeImageURL;
  patientid: any;
  params: any;
  ques: any;
  app: any;
  public myobj: any = {};
  public carepath: any = {};
  public apiurl: any = environment.api_url;
  public obj: any = {};
  public myobj1: any = {};
  resabs: any;
  resab: any;
  modalRef: any;
  CurrentUser: User;
  surgeoninfo: any = [];
  public patid: any;
  spantrue: boolean;
  homedata: any;
  checkabout: any;

  constructor(
    private toast: ToastrService,
    private activeroute: ActivatedRoute,
    private routers: Router,
    private patientservice: PatientService,
    private userservice: UserService,
    private modalService: BsModalService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {

    this.activeroute.params.subscribe(params => {
      this.params = params

      //////console.log(this.params.id)
    });

    this.userservice.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        // this.CurrentUser.status = false
        ////console.log(this.CurrentUser.item, "CurrentUser");
      }

    );

    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    this.CurrentUser.operationStatus = 'material'
    this.CurrentUser.operationMessage = ''

    // this.userservice
    // .postuserinfoid(1,this.CurrentUser.item.userAccountId)
    this.userservice
      .getusersession()
      .subscribe(
        data => {
          this.surgeoninfo = data[0].patientStageWorkflow[0]
          ////console.log(this.surgeoninfo)

        }

      );

    this.patientservice
      .getprofile(this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {

          this.ques = data.profileQuestions;

        }
      );


  }








  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }



  submitabout() {
    this.resabs = " ";
    //////console.log(this.ques);
    this.myobj.profileQuestions = "";
    this.myobj.profileQuestions = this.ques;
    //////console.log("ques:", this.ques,"obj:",this.myobj);
    if (this.myobj.profileQuestions[0].answer != "" && this.myobj.profileQuestions[1].answer != "" && this.myobj.profileQuestions[2].answer != "" && this.myobj.profileQuestions[3].answer != "") {
      //////console.log("in");
      // let profile ={
      //   "profileQuestions":this.myobj,
      //   "PatientId":this.params.patid
      // }
      this.myobj.userAccountId = this.CurrentUser.item.userAccountId;
      this.myobj.isProfileDone = false
      this.myobj.patientId = this.surgeoninfo.patientId
      ////console.log(this.myobj)
      this.patientservice.savequestion(this.myobj)
        .subscribe(
          data => {
            //////console.log(data);
            if (data.updateStatus == "true") {


              this.routers.navigate([`/patient/dashboard`])
              this.toast.success(this.userservice.translateText('patient_portal.display_messages.saved_successfully'))
              // this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
              // this.success.componentInstance.assessment = 'activity';
              // this.success.componentInstance.message = 'completed';
            } else {
              this.resabs = this.userservice.translateText('hospital_portal.disp_messages.enter_valid_data.errormsg');

            }

          }
        );

    } else {
      this.resabs = this.userservice.translateText('patient_portal.validations.enter_all_fields.error_label');
      //////console.log("Out");
    }
  }
  login() {
    this.resabs = " ";
    //////console.log(this.ques);
    this.myobj.profileQuestions = "";
    this.myobj.profileQuestions = this.ques;
    //////console.log("ques:", this.ques,"obj:",this.myobj);
    if (this.myobj.profileQuestions[0].answer != "" && this.myobj.profileQuestions[1].answer != "" && this.myobj.profileQuestions[2].answer != "" && this.myobj.profileQuestions[3].answer != "") {
      //////console.log("in");
      // let profile ={
      //   "profileQuestions":this.myobj,
      //   "PatientId":this.params.patid
      // }
      this.myobj.userAccountId = this.params.patid;
      //////console.log(this.myobj)
      this.patientservice.savequestion(this.myobj)
        .subscribe(
          data => {
            //////console.log(data);
            if (data.updateStatus == "true") {

              // this.resab = "Updated successfully";
              //  this.modalRef = this.modalService.show(tempabout,{class: 'modal-sm'});
              this.routers.navigate([`/helpdesk`])

            } else {
              this.resabs = this.userservice.translateText('hospital_portal.disp_messages.enter_valid_data.errormsg');

            }

          }
        );

    } else {
      this.resabs = this.userservice.translateText('patient_portal.validations.enter_all_fields.error_label');
      //////console.log("Out");
    }
  }

  goback() {
    this.patientid = window.localStorage['Puser'];
    this.routers.navigate([`/patient/dashboard`])
    /*  this.userservice
     .goback(this.patientid,'isProfileDone')
     .subscribe(
       data => {
         if(data){
           this.routers.navigate([`/patient/dashboard`])
           
         }
       }
     ); */
  }
}
